module.exports = __webpack_public_path__ + "img/vehicle-test-08.50fa8323.png";